(() => {
  const TYPOGRAPHY_PROPERTIES = new Set([
    'font',
    'font-family',
    'font-size',
    'font-stretch',
    'font-style',
    'line-height',
    'letter-spacing',
    'text-transform'
  ]);

  function normalizeInlineStyle(element) {
    const style = element.getAttribute('style');
    if (!style) return;

    const safeRules = style
      .split(';')
      .map((rule) => rule.trim())
      .filter(Boolean)
      .filter((rule) => {
        const property = rule.split(':')[0].trim().toLowerCase();
        return !TYPOGRAPHY_PROPERTIES.has(property);
      });

    if (safeRules.length) {
      element.setAttribute('style', safeRules.join('; '));
    } else {
      element.removeAttribute('style');
    }
  }

  function normalizeDescription(root) {
    root.classList.add('product-description--normalized');
    root.querySelectorAll('[style]').forEach(normalizeInlineStyle);
    root.querySelectorAll('font').forEach((element) => {
      element.removeAttribute('face');
      element.removeAttribute('size');
    });
  }

  function normalizeAllDescriptions(scope = document) {
    scope.querySelectorAll('.product-description').forEach(normalizeDescription);
  }

  document.addEventListener('DOMContentLoaded', () => normalizeAllDescriptions());
  document.addEventListener('shopify:section:load', (event) => normalizeAllDescriptions(event.target));
})();
